import { render } from "./MaxVerifyAttemptsReached.vue?vue&type=template&id=2d8e9ddd&scoped=true"
import script from "./MaxVerifyAttemptsReached.vue?vue&type=script&lang=js"
export * from "./MaxVerifyAttemptsReached.vue?vue&type=script&lang=js"

import "./MaxVerifyAttemptsReached.vue?vue&type=style&index=0&id=2d8e9ddd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8e9ddd"]])

export default __exports__